import { randomArrayItem } from "./randomArrayItem";

export const randomBool = () => randomArrayItem([true, false]);
